// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2aZvn","row":"Node_row__2YzLy","label":"Node_label__10hYi","footer":"Node_footer__3Xkrw"};